// PerformanceSection.jsx
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./performance.css";

const PerformanceSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
    AOS.refresh();
  }, []);

  return (
    <div className="performance-container">
      <div className="performance-content">
        <div className="performance-header" data-aos="fade-up">
          <h1 className="performance-title">
            Desempenho com
            <br />
            <span className="performance-highlight">resultados visíveis</span>
          </h1>
        </div>

        <div className="metrics-grid" data-aos="fade-up">
          <div className="metric-item">
            <h2 className="metric-value">56+</h2>
            <p className="metric-label">
              Propriedades
              <br />
              Geridas
            </p>
          </div>
          <div className="metric-item">
            <h2 className="metric-value">2M€+</h2>
            <p className="metric-label">
              Valor de
              <br />
              Arrendamento
            </p>
          </div>
          <div className="metric-item">
            <h2 className="metric-value">90%+</h2>
            <p className="metric-label">
              Retenção
              <br />
              de Clientes
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerformanceSection;